import moment from "moment";

const ageFromDate = (birthday, date = null) => {
    const onDate = date ? moment(date) : moment();
    return onDate.diff(birthday, 'year');
};

export default ageFromDate;
